
<template>
  <div>
    <div class="sifarnik-top-line">
      <div class="crm-top cases-top">
        <div class="cases-top-left">
          <navigation-office-management
            :active_link="2"
          ></navigation-office-management>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NavigationOfficeManagement from '../../../../components/officeManagement/NavigationOfficeManagement.vue';
export default{
    components : {
        NavigationOfficeManagement
    }
}
</script>
